module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00056-fs8.c9a351c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00056-fs8.png
// module id = 209
// module chunks = 0